import React, { forwardRef, useEffect, useState } from 'react';

import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'componentes/common/IconButton.js';

const RangeDateInput = forwardRef(({ value, onClick }, ref) => (
  <div className="position-relative">
    <Form.Control
      size="sm"
      ref={ref}
      onClick={onClick}
      value={value}
      className="ps-4"
      onChange={e => {
        console.log({ e });
      }}
    />
    <FontAwesomeIcon
      icon="calendar-alt"
      className="text-primary position-absolute top-50 translate-middle-y ms-2"
    />
  </div>
));

RangeDateInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
};
const DateRange = ({ setDateFrom, setDateTo, dateFrom, dateTo }) => {
  const [filterOptions, setFilterOptions] = useState(null);
  const [selectedOption, setSelectedOption] = useState(0);
  const [showRange, setShowRange] = useState(false);
  useEffect(() => {
    var optionsFilter = [];
    optionsFilter.push({ label: 'Todos', value: '0' });
    optionsFilter.push({ label: 'Hoy', value: '1' });
    optionsFilter.push({ label: 'Mes Actual', value: '2' });
    optionsFilter.push({ label: 'Últimos 30 días', value: '3' });
    optionsFilter.push({ label: 'Personalizado', value: '5' });
    setFilterOptions(optionsFilter);
  }, []);

  const onChange = dates => {
    const [start, end] = dates;
    setDateFrom(start);
    setDateTo(end);
  };

  useEffect(() => {
    if (selectedOption === '5') {
      setShowRange(true);
    } else {
      setShowRange(false);
      const now = new Date();
      switch (selectedOption) {
        case '1':
          setDateFrom(now);
          setDateTo(now);
          break;
        case '2':
          setDateFrom(new Date(now.getFullYear(), now.getMonth(), 1));
          setDateTo(new Date(now.getFullYear(), now.getMonth() + 1, 0));
          break;
        case '3':
          setDateFrom(new Date(now.setDate(now.getDate() - 30)));
          setDateTo(new Date());
          break;
        default:
          setDateFrom(null);
          setDateTo(null);
          break;
      }
    }
  }, [selectedOption]);
  return (
    <div>
      {!showRange ? (
        <div style={{ width: '250px' }}>
          <select
            aria-label="Default select"
            name="selectedRange"
            id="selectedRange"
            className="form-control"
            onChange={e => {
              setSelectedOption(e.target.value);
            }}
            value={`${selectedOption}`}
            style={{ minWidth: '250px', height: '30px' }}
          >
            <option key={'location_0'} value="">
              Selecciona un Periodo
            </option>
            {!!filterOptions?.length &&
              filterOptions.map(filter => (
                <option key={filter.value} value={filter.value}>
                  {filter.label}
                </option>
              ))}
          </select>
        </div>
      ) : (
        <div
          style={{
            width: '450px',
            display: 'inline-flex',
            alignItems: 'center',
            padding: '5px'
          }}
        >
          <IconButton
            className="me-1 mb-1"
            variant="falcon-default"
            icon="arrow-left"
            style={{
              display: 'inline-flex',
              paddingTop: '5px 2px 2px 2px',
              alignItems: 'center'
            }}
            size="sm"
            transform="shrink-3"
            onClick={() => setShowRange(!showRange)}
          ></IconButton>

          <DatePicker
            selected={dateFrom}
            onChange={onChange}
            startDate={dateFrom}
            style={{ display: 'inline-flex', alignItems: 'center' }}
            formatWeekDay={day => day.slice(0, 3)}
            endDate={dateTo}
            selectsRange
            dateFormat="MMM dd"
            customInput={<RangeDateInput />}
          />
        </div>
      )}
    </div>
  );
};
DateRange.propTypes = {
  setDateFrom: PropTypes.func.isRequired,
  setDateTo: PropTypes.func.isRequired,
  dateFrom: PropTypes.instanceOf(Date),
  dateTo: PropTypes.instanceOf(Date)
};
export default DateRange;
